<ng-container *adaptLoadingUntilFirstEmit="let position of position$">
    @if (position) {
        <adapt-dashboard-element name="Position">
            <div adapt-dashboard-title-buttons
                 *adaptIfAuthorised="ManagePositionAndRoles; entity: position.connection.person">
                @if (editMode) {
                    <button adaptButton="editBorderless"
                            (click)="editPosition(position)"></button>
                }
            </div>
            <span>{{ position.name }}</span>
        </adapt-dashboard-element>
    }
</ng-container>
